/*
 * @ Author: wangjiyu
 * @Date: 2019-10-31 16:11:14
 * @LastEditTime: 2019-11-05 17:27:20
 * @LastEditors: wangjiyu
 * @Description: file content
 */
import md5 from 'blueimp-md5';
import Message from '@/component/message';

const whiteList = ['.lixiang.com', '.ampmake.com'];

export default {
    getScript(
        url: string,
        callback?: (this: GlobalEventHandlers, ev: Event) => any
    ) {
        const script = document.createElement('script');
        script.src = url;
        script.async = true;
        if (callback) {
            script.onload = callback;
        }
        document.head.appendChild(script);
    },
    // md5加密
    securityCheck(params?: any) {
        const result = md5(params ? JSON.stringify(params) : '');
        const time = new Date().getTime();
        const key = 'uajskakf893jd';
        const no = md5(
            (
                Math.round(Math.random() * 10000) +
                Math.random() +
                time
            ).toString()
        );
        const sign = md5(result + time + no + key);
        return `time=${time}&no=${no}&sign=${sign}`;
    },
    getQueryStringByName(name: string, url?: string) {
        if (!url) {
            url = location.search;
        }
        const result = url.match(new RegExp(`[?&]${name}=([^&]+)`, 'i'));
        if (result == null || result.length < 1) {
            return '';
        }
        return result[1];
    },
    jump(url: string, replace?: boolean) {
        // 参数为url字符串
        if (url) {
            if (window.globalData.isServerEnv) {
                let passed = false;
                const domain = url.substr(
                    url.indexOf('.'),
                    url.indexOf('/', url.indexOf('/') + 2) -
                        url.indexOf('.') +
                        1
                );
                for (let i = 0; i < whiteList.length; i++) {
                    const item = whiteList[i];
                    if (domain.indexOf(`${item}/`) === 0) {
                        passed = true;
                        break;
                    }
                }
                if (passed) {
                    if (replace) {
                        location.replace(url);
                    } else {
                        location.href = url;
                    }
                } else {
                    console.log('bad url');
                }
            } else if (replace) {
                location.replace(url);
            } else {
                location.href = url;
            }
        } else if (replace) {
            location.replace('/');
        } else {
            location.href = '/';
        }
    },
    goLogin(href?: string) {
        if (!href) {
            href = location.href;
        }
        location.href = `/login.html?originalUrl=${encodeURIComponent(href)}`;
    },
    throwError(error: any, callback?: () => void) {
        const { response, status } = error;
        if (status === 401) {
            // let loginErr = '';
            // if (response && response.errors && response.errors[0].errorCode === 'LOGIN_BY_OTHER_DEVICE') {
            //     loginErr = 'isAbnormalLogin';
            // }
            this.goLogin('');
        } else if (status === 0 || status === 504) {
            Message.error('网络异常，请稍后再试！');
        } else if (response && response.errors) {
            Message.error(response.errors[0].message);
        } else {
            Message.error('未知错误！');
            console.error(error);
        }
        if (typeof callback === 'function') {
            const timer3 = setTimeout(() => {
                callback();
                clearTimeout(timer3);
            }, 1500);
        }
    },
    // 获取cookie
    getCookie(name: string) {
        if (document.cookie.length > 0) {
            let start = document.cookie.indexOf(`${name}=`);
            if (start !== -1) {
                start = start + name.length + 1;
                let end = document.cookie.indexOf(';', start);
                if (end === -1) end = document.cookie.length;
                return unescape(document.cookie.substring(start, end));
            }
        }
        return '';
    }
};
